// extracted by mini-css-extract-plugin
module.exports = {"link":"details-link_link__EkQDj"};